import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import DashboardPage from "@/pages/DashboardPage";
import CalendarPage from "@/pages/CalendarPage";
import RecipesPage from "@/pages/RecipesPage";
import BonusPage from "@/pages/BonusPage";
import ChatPage from "@/pages/ChatPage";
import ResourcesPage from "@/pages/ResourcesPage";
import FreeGuidePage from "@/pages/FreeGuidePage";
import BlogPage from "@/pages/BlogPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PatternDetectorPage from "@/pages/PatternDetectorPage";
import ShareStoryPage from "@/pages/ShareStoryPage";
import DataPage from "@/pages/DataPage";
import CommunityPage from "@/pages/CommunityPage";
import StreetStoriesPage from "@/pages/StreetStoriesPage";
import AdminPage from "@/pages/AdminPage";
import EssayContestPage from "@/pages/EssayContestPage";
import NeuroThryvPage from "@/pages/NeuroThryvPage";
import WeeklyPromptsPage from "@/pages/WeeklyPromptsPage";
import RecoveryPlanPage from "@/pages/RecoveryPlanPage";
import MessagesPage from "@/pages/MessagesPage";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/recipes" element={<RecipesPage />} />
            <Route path="/bonus" element={<BonusPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/free-guide" element={<FreeGuidePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/pattern-detector" element={<PatternDetectorPage />} />
            <Route path="/share-story" element={<ShareStoryPage />} />
            <Route path="/data" element={<DataPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/street-stories" element={<StreetStoriesPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/essay-contest" element={<EssayContestPage />} />
            <Route path="/neurothryv" element={<NeuroThryvPage />} />
            <Route path="/weekly-prompts" element={<WeeklyPromptsPage />} />
            <Route path="/recovery-plan" element={<RecoveryPlanPage />} />
            <Route path="/messages" element={<MessagesPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
